var throttling = function (fn, wait) {
  if (wait === void 0) {
    wait = 500;
  }
  var timer;
  var context, args;
  var run = function () {
    timer = setTimeout(function () {
      fn.apply(context, args);
      clearTimeout(timer);
      timer = null;
    }, wait);
  };
  return function (p) {
    // @ts-ignore
    context = this;
    args = arguments;
    p.persist();
    if (!timer) {
      // console.log("throttle, set");
      run();
    }
  };
};
export default throttling;